import { ApiResourceModel } from "../ApiResourceModel";
export class ApiSearchResult extends ApiResourceModel {
    constructor(args) {
        super();
        // super(args);
        this.content = args.content;
        this.page = {
            number: args.number,
            size: args.size,
            first: args.first,
            last: args.last,
            total: args.totalPages,
        };
        this.numberOfElements = args.numberOfElements;
        this.totalElements = args.totalElements;
        this.sort = args.sort;
    }
}
ApiSearchResult.EMPTY = new ApiSearchResult({
    content: [],
    number: 0,
    size: 0,
    last: true,
    first: true,
    totalPages: 0,
    totalElements: 0,
    numberOfElements: 0,
    sort: "asc",
});
//# sourceMappingURL=ApiSearchResult.js.map